import { Flex, Link } from "@chakra-ui/react";
import { BiTrash } from "react-icons/bi";

const ButtonDelete = ({ onClick }) => {
  return (
    <Flex w="100%" align="center" justify="center" h="100%" onClick={onClick}>
      <Link color="red.500">
        <BiTrash size="1.3rem" />
      </Link>
    </Flex>
  );
};

export default ButtonDelete;
